import api from '../utils/interceptor';
const API_URL = process.env.REACT_APP_API_URL;

// Create Contact Inquiry Service
export const createContactInquiryService = async (data) => {
    try {
        const response = await api.post(API_URL + 'contact-inquiry', data);
        return response;
    } catch (error) {
        console.error('Error creating contact inquiry :', error);
        throw error;
    }
};


